export default "__VITE_ASSET__3723a906__"